export default __webpack_public_path__ + "static/media/Luffa.43552181.jpg";